var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("swb-query-sort-area", {
        ref: "query_model",
        attrs: { config: _vm.queryConfig, queryHandler: _vm.queryHandler }
      }),
      _vm._v(" "),
      _c(
        "el-table",
        {
          ref: "multipleTable",
          staticClass: "mt10",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.orderGoodsAllocFormList,
            "row-key": _vm.getRowKeys,
            border: "",
            "highlight-current-row": ""
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "selection-change": _vm.handleSelectionChange
          }
        },
        [
          !_vm.multiSelect
            ? _c("el-table-column", {
                key: Math.random(),
                attrs: { width: "55" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: rows.row.id },
                            model: {
                              value: _vm.orderGoodsAllocForm.id,
                              callback: function($$v) {
                                _vm.$set(_vm.orderGoodsAllocForm, "id", $$v)
                              },
                              expression: "orderGoodsAllocForm.id"
                            }
                          },
                          [_vm._v(" ")]
                        )
                      ]
                    }
                  }
                ])
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.multiSelect
            ? _c("el-table-column", {
                key: Math.random(),
                attrs: {
                  width: "55",
                  selectable: _vm.selectable,
                  align: "center",
                  type: "selection"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "title",
              label: "配货单名称",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "orderNo",
              label: "订单编号",
              align: "center",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "buyerName",
              label: "买家名称",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "buyerShopName",
              label: "买家业务单元",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "buyerBizUnitName",
              label: "买家所属部门",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "buyerRecvAddr",
              label: "地址信息",
              align: "left",
              "show-overflow-tooltip": ""
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            key: Math.random(),
            attrs: {
              prop: "createTime",
              label: "创建时间",
              align: "left",
              "show-overflow-tooltip": ""
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "block pagination-layout" },
        [
          _c("el-pagination", {
            staticClass: "mt10",
            attrs: {
              background: "",
              "page-size": _vm.pageSize,
              "page-sizes": _vm.pageSizes,
              "current-page": _vm.pageNumber,
              total: _vm.totalCount,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-df210a38", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df210a38","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocFormForSelect.vue
// module id = 1827
// module chunks = 1